module.exports = __webpack_public_path__ + "static/media/fern-2.8bdea8ec.fbx";